import { ToastContainer } from "react-toastify";
import Sidenav from "../templates/sidenav-template";
import React, { useEffect, useState, useRef } from 'react';
import { CAMERA_MANAGER } from "../components/camera-manager";
import { LOG_RECORDS_MANAGER } from "../components/log-records-manager";
import Loader from "../templates/loader-template";
import { TOAST_FAIL, TOAST_INFO, TOAST_FORM, TOAST_INFO_1 } from "../components/toasters";
import { Button } from 'react-bootstrap';
import { toast } from "react-toastify";

function HomePage() {
    const [cameras, setCameras] = useState([]);
    const alarmAudioRef = useRef(null);
    const isToastFormActiveRef = useRef(false);
    const isToastInfo1ActiveRef = useRef(false);
    const [loader, setLoader] = useState(false);
    const [counts, setCounts] = useState([]);
    const [visitors, setVisitors] = useState([]);
    const [dropoffs, setDropoffs] = useState([]);
    const { CAMERA_FETCH } = CAMERA_MANAGER();
    const { VEHICLE_COUNT_FETCH, VEHICLE_VISITOR_FETCH, VEHICLE_UPDATE_LOG, VEHICLE_DROPOFF_FETCH } = LOG_RECORDS_MANAGER();
    // const ip = "http://localhost:5000";
    const ip = "https://api.lnu-vms.online";
    const [editablePlateNumber, setEditablePlateNumber] = useState("");
    const formRef = useRef(null);
    
    const fetchVehicleCount = async () => {
        const data = await VEHICLE_COUNT_FETCH();
        setCounts(data);
    }

    const handleChange = (event) => {
        const field = event.target.name;
        setEditablePlateNumber((prevState) => ({
            ...prevState,
            [field]: event.target.value,
        }));
    };

    const fetchVisitorVehicles = async () => {
        await VEHICLE_VISITOR_FETCH()
            .then(visitors => {
                if (visitors && visitors.length > 0) {
                    setVisitors(visitors);
                    const plateNumbers = visitors.map(visitor => visitor.plate_number).join(", ");
                    TOAST_FAIL(
                        <>
                            <p>The following vehicles are still inside the campus:</p> <br />
                            {plateNumbers}
                        </>
                    );
                } else {
                    setVisitors([]);
                    TOAST_INFO("There are no visitors inside the campus");
                }
            });
    }

    const fetchCameras = async () => {
        const data = await CAMERA_FETCH();
        setCameras(data);
        setLoader(false);
    };

    const toastSubmit = (identityValue) => {
        const formData = new FormData(document.querySelector('form')); // Get the form data
        const plate_number = formData.get("plate_number"); // Extract plate_number from the form
    
        if (!plate_number || !identityValue) {
            toast.error("Missing required fields.");
            return;
        }
    
        // Call VEHICLE_UPDATE_LOG with plate_number and identityValue
        VEHICLE_UPDATE_LOG(plate_number, identityValue);
        isToastFormActiveRef.current = false;
        fetchVehicleCount();
    };

    const fetchDropoffVehicles = async() => {
        await VEHICLE_DROPOFF_FETCH()
        .then(dropoffs => {
            if (dropoffs && dropoffs.length > 0) {
                setDropoffs(dropoffs);
                const plateNumbers = dropoffs.map(dropoff => dropoff.plate_number).join(", ");
                    TOAST_INFO_1(<>
                        <p>The following vehicles exceeded their allowed time inside the campus:</p><br />
                        {plateNumbers}
                       </>, {
                        onClose: () => {isToastInfo1ActiveRef.current = false}
                       }
                    );
            } else {
                setDropoffs([]);
            }
        })
    }

    useEffect(() => {
        setLoader(true);
        fetchCameras();
        fetchVehicleCount();
        isToastFormActiveRef.current = false;

        const interval = setInterval(() => {
            fetchAlarmMessage();
            fetchInfo();
            fetchDropoffVehicles();
        }, 1000);
        return () => clearInterval(interval);
    }, []);

    // Helper function to format date
    const formatDateTime = (dateString) => {
        if (!dateString) {
            return "N/A";
        }
    
        // Convert to a Date object
        const date = new Date(dateString);
    
        // Format the date with options
        const options = { 
            year: 'numeric', 
            month: 'long', 
            day: 'numeric', 
            hour: 'numeric', 
            minute: 'numeric', 
            hour12: true,
            timeZone: 'Asia/Manila' // Explicitly set the Manila timezone
        };
    
        return new Intl.DateTimeFormat('en-US', options).format(date);
    };

// Bind keys to identity values
const handleKeyPress = (event) => {
    if (!isToastFormActiveRef.current) return;

    if (event.key === "Escape") {
        toast.dismiss(); // Dismiss the toast
        isToastFormActiveRef.current = false;
        return;
    }

    let identityValue;

    // Determine identity based on the pressed key
    switch (event.key) {
        case "1": identityValue = "Employee"; break;
        case "2": identityValue = "Visitor"; break;
        case "3": identityValue = "Dropoff"; break;
        case "4": identityValue = "ILS Parent"; break;
        default: return;
    }

    // Directly call the function to handle the submission
    isToastFormActiveRef.current = false;
    toastSubmit(identityValue); // Pass identityValue directly
    toast.dismiss(); // Dismiss the toast after submission
};

    document.addEventListener("keydown", handleKeyPress);

    // Clean up the event listener when the toast form closes
    TOAST_FORM.onClose = () => {
        isToastFormActiveRef.current = false;
        document.removeEventListener("keydown", handleKeyPress);
    };

    const fetchInfo = async() => {
        fetchVehicleCount();
        const response = await fetch(`${ ip }/send-info`);
        const data = await response.json();

        if (data.message === "Info") {
            TOAST_INFO(
                <>
                    <b>Plate number:</b> {data.plate_number}<br/>
                    <b>Owner Name:</b> {data.username}<br/>
                    <b>Email:</b> {data.email}<br/>
                    <b>Identity:</b> {data.identity}<br/>
                    <b>Time In:</b> {formatDateTime(data.time_in)}<br/>
                    <b>Time Out:</b> {formatDateTime(data.time_out)}
                </>
            );
            fetchVehicleCount();
        } else if (data.message === "New Info") {
            setEditablePlateNumber(data.plate_number);
            if (isToastFormActiveRef.current === false) {
                isToastFormActiveRef.current = true;
                TOAST_FORM(
                    <form onSubmit={(event) => event.preventDefault()}>
                        <div className="mb-1">
                            <b>Plate number:  </b>
                            <input
                                className="toast-form-input rounded ps-2"
                                name="plate_number"
                                value={`${data.plate_number}  (Unregistered)`}
                                onChange={handleChange}
                                required
                            />
                            <br />
                        </div>
                        <b>Time In:</b> {formatDateTime(data.time_in)}<br />
                        <b>Time Out:</b> {formatDateTime(data.time_out)}<br />
                    
                        <div className="mt-3">
                            <Button
                                variant="success"
                                className="toast-form-button me-2"
                                onClick={(event) => {
                                    toastSubmit(event, "Employee");
                                    isToastFormActiveRef.current = false;
                                }}
                                disabled
                            >
                                ( 1 )
                                Employee
                            </Button>
                            <Button
                                variant="success"
                                className="toast-form-button me-2"
                                onClick={(event) => {
                                    toastSubmit(event, "Visitor");
                                    isToastFormActiveRef.current = false;
                                }}
                                disabled
                            >
                                ( 2 )
                                Visitor
                            </Button>
                            <Button
                                variant="success"
                                className="toast-form-button me-2"
                                onClick={(event) => {
                                    toastSubmit(event, "Drop-off");
                                    isToastFormActiveRef.current = false;
                                }}
                                disabled
                            >
                                ( 3 )
                                Drop-off
                            </Button>
                            <Button
                                variant="success"
                                className="toast-form-button"
                                onClick={(event) => {
                                    toastSubmit(event, "ILS Parent")
                                    isToastFormActiveRef.current = false;
                                }}
                                disabled
                            >
                                ( 4 )
                                ILS Parent
                            </Button>
                        </div>
                    </form>,
                    {
                        onClose: () => {
                            console.log("Toast closed");
                            isToastFormActiveRef.current = false;
                            document.removeEventListener("keydown", handleKeyPress);
                        },
                    }
                );
            }   
        }
    }

    const fetchAlarmMessage = async () => {
        const response = await fetch(`${ ip }/send-alarm`);
        const data = await response.json();

        if (data.message === "Alarm") {
            // Play the alarm sound if the message is "Alarm"
            TOAST_FAIL(<>
                        <p>The following vehicles are still inside the campus:</p><br />
                        
                       </>);

            if (alarmAudioRef.current) {
                alarmAudioRef.current.play();
            }
        }
    };

    return (
        <div className="d-flex home-page">
            <ToastContainer />
            <div className="sidenav-position">
                <Sidenav />
            </div>
            <div className="feed-container">
                <div className="vehicle-count-container d-flex column justify-content-evenly pt-2 text-white">
                    <p>
                        <b>EMPLOYEES : </b> { counts.Employee }
                    </p>
                    <p className="">
                        <b>DROP-OFFS : </b>
                        <span className={counts.Dropoff >= 2 ? "text-danger" : "text-white"}>{ counts.Dropoff }</span> / 2
                    </p>
                    <p className="">
                        <b>ILS Parents : </b><span>{ counts.ILSparent }</span> / 2
                    </p>
                    <p>
                        <b>VISITORS : </b>
                        <span className={counts.Visitor >= 5 ? "text-danger" : "text-white"}>
                            { counts.Visitor } / 5
                        </span>
                    </p>
                    <button className="header-button rounded" onClick={() => fetchVisitorVehicles()}>
                        Check vehicles
                    </button>

                </div>
                {loader? (
                    <Loader text={ "Fetching All Cameras" }/>
                ) : cameras.length === 0 ? (
                    <p className="no-camera-message text-center mt-5">No cameras found</p>
                ) : (
                    <div className="video-container column mt-2 gap-2 me-3">
                        {cameras.map(camera => (
                            <div key={camera.id} className="video-feed-container rounded-1">
                                <p className="ps-3">{camera.camera_type} ({camera.location})</p>
                                <img
                                    alt="video-feed"
                                    className="video-feed rounded-1"
                                    src={`${ ip }/video_feed/${ camera.id }`}
                                ></img>
                            </div>
                        ))}
                    </div>
                )}
            </div>

        </div>
    )
}

export default HomePage;